import {
  Grid,
  Link,
} from '@mui/material';
import {styled} from '@mui/system';

export const PolicyTermsContainer = styled(Grid)(({theme}) => ({
  fontSize: '12px',
  width: '100%',
  padding: '8px 24px 24px 24px',
  [theme.breakpoints.up('sm')]: {
    // position: 'absolute',
    bottom: '0px',
    left: '0px',
  },
}));

export const StyledLink = styled(Link)(({theme}) => ({
  color: theme.palette.text.tertiary,
  display: 'inline-block',
  fontSize: '12px',
  fontWeight: 400,
}));
